export interface InstallmentOption {
  value: string;
  label: string;
  surcharges?: string | null;
}

export class InstallmentsManager {
  public static formatOptions(options: any[], formatFnCallback?: any) {
    if (!options || !Array.isArray(options)) return []

    return options.map((option) => {
      const surcharges =
        option.total < (option?.totalWithSurcharges ?? 0) || option.useRate;
      const surchargesText = `${surcharges ? 'creditCardForm.installmentsSelect.withSurcharges' : 'creditCardForm.installmentsSelect.withoutSurcharges' }`;

      const label = formatFnCallback
        ? `${option.label} ${formatFnCallback({ id: surchargesText})}`
        : option.label;

      return {
        value: option.value,
        label,
        surcharges: '',
      };
    });
  }

  public static handleInstallmentsChange(
    value: string,
    options: InstallmentOption[],
    setInstallments: (val: number) => void,
    setInstallmentsExplanationText: (text: string) => void,
    setSurchargesText: (text: string | null) => void
  ) {
    setInstallments(Number(value));
    const installmentOption = options.find((item) => item.value === value);
    setInstallmentsExplanationText(installmentOption?.label || '');
    setSurchargesText(installmentOption?.surcharges || null);
  }
}
